import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetCategory = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/categories/${uuid}`, 'GET', idToken)
}
  
export const UpdateCategory = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/categories/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteCategory = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/categories/${uuid}`, 'DELETE', idToken)
}